exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.size-tabela[data-v-1667a32e]{\n    width: 700px;\n}\n\n", ""]);

// exports
